import { useContext } from "react";

import { AppContext } from "config/appProvider";
import { hasFeature } from "helpers/general";
import { FEATURES } from "constants/Features";

export const useHasFeature = (feature: keyof typeof FEATURES): boolean => {
  const {
    mainAppState: { featuresList },
  } = useContext(AppContext);
  const isHasFeature: boolean = hasFeature(FEATURES[feature], featuresList);

  // if (__DEV__) {
  //   return true;
  // }

  return isHasFeature;
};
